import React from 'react';
import classnames from 'classnames';
import styles from './searchBadDescription.module.scss';
import { SearchEntity } from 'v2/models';
import { useIsReviewerUser } from 'v2/hooks';

interface SearchBadDescriptionProps {
  search: SearchEntity;
  showContent?: boolean;
}

const SearchBadDescription = ({
  search,
  showContent,
}: SearchBadDescriptionProps) => {
  const isReviewerUser = useIsReviewerUser();

  if (
    !isReviewerUser ||
    search.review_status !== 'under_review' ||
    !search.last_check_description ||
    search.last_check_description.result !== 'bad'
  ) {
    return null;
  }

  return (
    <div
      role="alert"
      className={classnames('flex-column', styles.container, {
        [styles.notShowContent]: !showContent,
      })}
    >
      <div className={classnames('d-flex', { [styles.check]: showContent })}>
        <div className="d-flex flex-column">
          <span className={classnames(styles.title)}>
            Request isn&apos;t well formed
          </span>
          {showContent && (
            <div className="mt-4">{search.last_check_description.feedback}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchBadDescription;
